import Vue from 'vue';
import SimpleVueValidation from 'simple-vue-validator';

const Validator = SimpleVueValidation.Validator;

Vue.use(SimpleVueValidation);

export default {
    data() {
        return {
            price:'',
            point:'',
            bonus:'',
            itemKey: 0,
            title: ''

        }
    },
    computed: {

    },

    validators: {
        title: function (value) {
            return Validator.value(value)
                .required('상품명을 입력해주세요.')
        },
        price: function (value) {
            return Validator.value(value)
                .required('상품금액을 입력해주세요.')
        },
        point: function (value) {
            return Validator.value(value)
                .required('충전밍글을 입력해주세요.')
        },
        bonus: function (value) {
            return Validator.value(value)
                .required('추가밍글을 입력해주세요.')
        },
    },
    methods: {}
}
